export default __webpack_public_path__ + "media/src/assets/images/pay (1)-7e90eb8e8fcd75295e2ef65043ac0133.png";